import Section from "../../components/UI/Section/Section";


import IconList from "../../components/UI/IconList/IconList";
import Icon from "../../components/UI/Icon/Icon";
import Header from "../../components/UI/Header/Header";
import ArrowBack from "../../components/ArrowBack/ArrowBack";


export default () => {


  return (
    <>
    <ArrowBack/>
    <Section>
        <Header>Описание</Header>
        <p>За успешное выполнение задач вы зарабатываете внутреннюю валюту - баффики, получаете достижения и улучшаете навыки.</p>
        <p>Чтобы взять задачу, необходимо нажать кнопку "откликнуться" и дождаться подтверждения администратора.</p>
        <p>Кроме положительных достижений предусмотрены достижения, ограничивающие ваши возможности. Например, за нарушение правил или сотавление мусора.</p>
        <p>За уточнениями обращайтесь к администраторам.</p>
    </Section>
    <Section>
          <Header>Достижения</Header>
      <IconList layout="vertical">
          <Icon className="Icon-list__item" image="cad" size="xl" title="САПР"/>
          <p className="Icon-list__item-desc">Выдается за прохождение курса "САПР".</p>
          <Icon className="Icon-list__item" image="3dp" size="xl" title="3Д-принтер"/>
          <p className="Icon-list__item-desc">Выдается за прохождение курса "<span style={{whiteSpace: "nowrap"}}>3Д-принтер</span>".</p>
          <Icon className="Icon-list__item" image="drill" size="xl" title="Фрезер"/>
          <p className="Icon-list__item-desc">Выдается за прохождение курса "Фрезер".</p>
          <Icon className="Icon-list__item" image="arduino" size="xl" title="Ардуино"/>
          <p className="Icon-list__item-desc">Выдается за прохождение курса "Ардуино".</p>
          <Icon className="Icon-list__item" image="vector" size="xl" title="Вектор"/>
          <p className="Icon-list__item-desc">Выдается за прохождение курса "Вектор".</p>
          <Icon className="Icon-list__item" image="laser" size="xl" title="Лазер"/>
          <p className="Icon-list__item-desc">Выдается за прохождение курса "Лазер".</p>
          <Icon className="Icon-list__item" image="novator" size="xl" title="Новатор"/>
          <p className="Icon-list__item-desc">Выдается за открытие новых направлений, новаторство.</p>
          <Icon className="Icon-list__item" image="independent" size="xl" title="Самостоятельное решение"/>
          <p className="Icon-list__item-desc">Выдается за инициативу, которая привела к результатам, которые необходимо отметить.</p>
          <Icon className="Icon-list__item" image="optimizer" size="xl" title="Предложение оптимизации"/>
          <p className="Icon-list__item-desc">Выдается за предложение оптимизации, которое необходимо отметить.</p>
          <Icon className="Icon-list__item" image="creative" size="xl" title="Креативное решение"/>
          <p className="Icon-list__item-desc">Выдается за креативные решения.</p>
          <Icon className="Icon-list__item" image="industrial" size="xl" title="Промышленный дизайн"/>
          <p className="Icon-list__item-desc">Выдается за достижения в промышленном дизайне.</p>
          <Icon className="Icon-list__item" image="informator" size="xl" title="Информационный дизайн"/>
          <p className="Icon-list__item-desc">Выдается за достижения в информационном дизайне.</p>
          <Icon className="Icon-list__item" image="graphical" size="xl" title="Графический дизайн"/>
          <p className="Icon-list__item-desc">Выдается за достижения в графическом дизайне.</p>
          <Icon className="Icon-list__item" image="teacher" size="xl" title="Преподаватель"/>
          <p className="Icon-list__item-desc">Выдается преподавателям.</p>
          <Icon className="Icon-list__item" image="steel" size="xl" title="Стальной характер"/>
          <p className="Icon-list__item-desc">За приверженность проекту, когда остальные уже потеряли в него веру.</p>         
      </IconList>
    </Section>
    <Section>
      <Header>Навыки</Header>
      <IconList layout="vertical">
        <Icon className="Icon-list__item" image="star2" size="xl" title="Дизайнер"/>
        <p className="Icon-list__item-desc">Выдается за выполнение творческих заданий.</p>
        <Icon className="Icon-list__item" image="bulp" size="xl" title="Инициатор"/>
        <p className="Icon-list__item-desc">Выдается за инициативу и помощь.</p>
        <Icon className="Icon-list__item" image="cog" size="xl" title="Инженер"/>
        <p className="Icon-list__item-desc">Выдается за выполнение заданий, требующих инженерных навыков.</p>
        <Icon className="Icon-list__item" image="project" size="xl" title="Проектник"/>
        <p className="Icon-list__item-desc">Выдается за разработку и выполнение собственных проектов.</p>
        <Icon className="Icon-list__item" image="smiley-talk" size="xl" title="Активист"/>
        <p className="Icon-list__item-desc">Выдается за участие в мероприятиях, популяризацию и общественную деятельность.</p>
      </IconList>
    </Section>
    <Section>
      <Header>Негативные</Header>
      <Icon className="Icon-list__item" image="penalty" size="xl" title="Грязный Луи"/>
          <p className="Icon-list__item-desc">Ачивка с негативным смыслом. Выдается за оставление грязи после себя.</p>
    </Section>
    <Section>
      <Header>Валюта</Header>
      <Icon className="Icon-list__item" image="baf" size="xl" title="Баффик"/>
          <p className="Icon-list__item-desc">Внутренняя валюта. Выдается за выполнение задач.</p>
    </Section>

    </>
  );
};
